import { useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import TextField from "@mui/material/TextField";
import { CircularProgress } from "@mui/material";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import { useDialogModalRedux } from "redux/slices/dialog/hooks/useDialogModalRedux";
import { useSimulateContributionsRebateMutation } from "redux/apis/rebateOffer";
import { RebateOfferResponse } from "interfaces/rebate-offer";
import { featureTrackerAPI } from "redux/apis";
import { FeatureType } from "interfaces/feature-tracker";
import { useWebStoreContext } from "contexts";

const SimulatePurchases = () => {
	const [open, setOpen] = useState<boolean>(false);
	const [fieldValue, setFieldValue] = useState<number>(1);
	const [simulateContributionsRebate, { isLoading }] =
		useSimulateContributionsRebateMutation();
	const { authToken } = useWebStoreContext();
	const { showErrorDialog } = useDialogModalRedux();
	const { data: rebateOfferData }: { data?: RebateOfferResponse } =
		featureTrackerAPI.endpoints.getFeatureTracker.useQueryState({
			FeatureType: FeatureType.REBATE_OFFER,
			isAuthenticated: !!authToken?.value
		});

	const handleOpen = (open: boolean) => {
		setOpen(open);
	};

	const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		setFieldValue(e.target.valueAsNumber);
	};

	const handleSetPurchases = async () => {
		await simulateContributionsRebate({
			body: {
				amount: fieldValue,
				trackerId: rebateOfferData?.rebateTracker?.id
			}
		})
			.unwrap()
			.then(() => {
				setOpen(false);
			})
			.catch((error) => {
				showErrorDialog({
					data: {
						errorCode: error?.status?.toString(),
						errorMessage: error?.data?.error?.toString()
					}
				});
			});
	};

	return (
		<div>
			<Button variant="outlined" onClick={() => handleOpen(true)}>
				{"Simulate Contributions"}
			</Button>
			<Dialog open={open} onClose={() => handleOpen(false)}>
				<DialogTitle>Submit</DialogTitle>
				<DialogContent>
					<TextField
						onChange={onChange}
						autoFocus
						margin="dense"
						id="name"
						defaultValue={fieldValue}
						label="Simulate Contributions Clicks"
						type="number"
						fullWidth
						variant="standard"
					/>
				</DialogContent>
				<DialogActions>
					<Button onClick={() => handleOpen(false)}>Cancel</Button>
					<Button onClick={handleSetPurchases}>
						{isLoading ? <CircularProgress size={"0.875rem"} /> : "Submit"}
					</Button>
				</DialogActions>
			</Dialog>
		</div>
	);
};

export default SimulatePurchases;
